import { IAPIRoutes } from "../../../../config";

export type IPrescriptionRepository = ReturnType<
  typeof PrescriptionRepositoryFactory
>;

export const PrescriptionRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, POST, DELETE } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getPrescriptions = async (payload: {
    clinic_id: number;
    patient_id: number;
  }): Promise<IGetPrescriptionsResponse> =>
    GET(
      APIRoutes.apiGetPrescriptions
        .replace("{clinic_id}", String(payload.clinic_id))
        .replace("{patient_id}", String(payload.patient_id)),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getPrescriptionById = async (payload: {
    clinic_id: number;
    patient_id: number;
    prescription_id: number;
  }): Promise<IGetPrescriptionResponse> =>
    GET(
      APIRoutes.apiGetPrescriptionById
        .replace("{clinic_id}", String(payload.clinic_id))
        .replace("{patient_id}", String(payload.patient_id))
        .replace("{prescription_id}", String(payload.prescription_id)),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const uploadPrescription = async (
    payload: IUploadPrescriptionPayload
  ): Promise<IUploadPrescriptionResponse> => {
    const formData = new FormData();
    formData.append("file", payload.file);
    formData.append("name", payload.name);
    formData.append("clinic_id", String(payload.clinic_id));
    formData.append("patient_id", String(payload.patient_id));
    if (payload.prescribed_by)
      formData.append("prescribed_by", payload.prescribed_by);
    if (payload.notes) formData.append("notes", payload.notes);
    if (payload.date_prescribed)
      formData.append("date_prescribed", payload.date_prescribed);

    return POST(
      APIRoutes.apiUploadPrescription
        .replace("{clinic_id}", String(payload.clinic_id))
        .replace("{patient_id}", String(payload.patient_id)),
      formData,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const deletePrescription = async (payload: {
    clinic_id: number;
    patient_id: number;
    prescription_id: number;
  }): Promise<IDeletePrescriptionResponse> =>
    DELETE(
      APIRoutes.apiDeletePrescription
        .replace("{clinic_id}", String(payload.clinic_id))
        .replace("{patient_id}", String(payload.patient_id))
        .replace("{prescription_id}", String(payload.prescription_id)),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getPrescriptions,
    getPrescriptionById,
    uploadPrescription,
    deletePrescription,
  };
};
